import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import de from "./locales/de.json";
import en from "./locales/en.json";
import ru from "./locales/ru.json";
import tr from "./locales/tr.json";
import hi from "./locales/hi.json";
import ar from "./locales/ar.json";
import es from "./locales/es.json";
import sq from "./locales/sq.json";
import fr from "./locales/fr.json";

export const LANGS = [
    { code: "de", name: "Deutsch", flag: "🇩🇪", dir: "ltr" },
    { code: "en", name: "English", flag: "🇬🇧", dir: "ltr" },
    { code: "tr", name: "Türkçe", flag: "🇹🇷", dir: "ltr" },
    { code: "ru", name: "Русский", flag: "🇷🇺", dir: "ltr" },
    { code: "ar", name: "العربية", flag: "🇸🇦", dir: "rtl" },
    { code: "hi", name: "हिन्दी", flag: "🇮🇳", dir: "ltr" },
    { code: "es", name: "Español", flag: "🇪🇸", dir: "ltr" },
    { code: "fr", name: "Français", flag: "🇫🇷", dir: "ltr" },
    { code: "sq", name: "Shqip", flag: "🇦🇱", dir: "ltr" },
];

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            de: { translation: de },
            en: { translation: en },
            ru: { translation: ru },
            tr: { translation: tr },
            hi: { translation: hi },
            ar: { translation: ar },
            es: { translation: es },
            sq: { translation: sq },
            fr: { translation: fr },
        },
        fallbackLng: "de",
        supportedLngs: ["de", "en", "ru", "tr", "hi", "ar", "es", "sq", "fr"],
        interpolation: { escapeValue: false },
        detection: {
            order: ["localStorage", "navigator", "htmlTag"],
            lookupLocalStorage: "b24_lang",
            caches: ["localStorage"],
        },
    });

// Apply <html dir="..."> on language change so Arabic flips to RTL
function applyDirection(lng) {
    const meta = LANGS.find((l) => l.code === lng);
    if (meta && typeof document !== "undefined") {
        document.documentElement.dir = meta.dir;
        document.documentElement.lang = meta.code;
    }
}
applyDirection(i18n.language);
i18n.on("languageChanged", applyDirection);

export default i18n;
